import { Card } from 'react-bootstrap';
import PropTypes from 'prop-types';

import MarketingExpensesChart, {
  MARKETING_CHART_MIN_HEIGHT
} from './MarketingExpensesChart';
import MarketingExpensesList from './MarketingExpensesList';
import PlotSkeleton from '../PlotSkeleton';
import FalconCardHeader from '@/components/common/FalconCardHeader';
import HelpTooltip from '@/app/common/components/HelpTooltip';
import { useRef } from 'react';
import CardChartDropDown from '@/components/common/CardChartDropDown';
import ReactEChartsCore from 'echarts-for-react/lib/core';

const TOP_ITEM_COUNT = 9;
/** Top items plus the grouped "Other" row — the tallest list this card renders. */
const GROUPED_LIST_SIZE = TOP_ITEM_COUNT + 1;

const groupItems = items => {
  if (!Array.isArray(items) || items.length <= TOP_ITEM_COUNT) {
    return items ?? [];
  }

  const topItems = items.slice(0, TOP_ITEM_COUNT);
  const otherValue = items
    .slice(TOP_ITEM_COUNT)
    .reduce((sum, item) => sum + Number(item?.value || 0), 0);

  return [...topItems, { name: 'Other', value: otherValue }];
};

const MarketingExpenses = ({
  listData,
  loading = false
}: Record<string, any>) => {
  const cardRef = useRef<HTMLDivElement | null>(null);
  const chartRef = useRef<ReactEChartsCore | null>(null);
  const chartData = {
    ...listData,
    tld: groupItems(listData?.tld),
    language: groupItems(listData?.language)
  };

  return (
    <Card className="h-100" ref={cardRef}>
      <FalconCardHeader
        title={
          <div>
            توزیع براساس زبان و پسوند
            <HelpTooltip html="زبان، زبان صفحهٔ ارجاع‌دهنده است و پسوند، پسوند دامنهٔ ارجاع‌دهنده را نشان می‌دهد." />
          </div>
        }
        titleTag="h6"
        className="py-2"
        light
        endEl={<CardChartDropDown cardRef={cardRef} chartRef={chartRef} />}
      />
      <Card.Body className="d-flex flex-column justify-content-between">
        {loading ? (
          <div className="position-relative py-2">
            <PlotSkeleton height={MARKETING_CHART_MIN_HEIGHT} />
          </div>
        ) : (
          <MarketingExpensesChart data={chartData} chartRef={chartRef} />
        )}
        <MarketingExpensesList
          data={chartData}
          placeholderCount={loading ? GROUPED_LIST_SIZE : 0}
        />
      </Card.Body>

      {/* <Card.Footer className="bg-body-tertiary py-2 d-flex">
        <div className="ms-auto">
          <Form.Select size="sm" className="me-2">
            <option>Last 7 days</option>
            <option>Last Month</option>
            <option>Last Year</option>
          </Form.Select>
        </div>
      </Card.Footer> */}
    </Card>
  );
};

MarketingExpenses.propTypes = {
  listData: PropTypes.shape({
    tld: PropTypes.arrayOf(PropTypes.object),
    language: PropTypes.arrayOf(PropTypes.object)
  }),
  loading: PropTypes.bool
};

export default MarketingExpenses;
